<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: "ProductAttributeComponent",
};
</script>

<style scoped></style>
